export default "__VITE_ASSET__G9sRqkOD__"